import React from "react";

const BankUserLookup = ({ mobile, setMobile, userInfo, isLoading }) => {
  return (
    <div className="mb-4">
      <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
        Mobile Number
      </label>
      <input
        type="text"
        maxLength={10}
        className="w-full p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
        placeholder="Enter 10 digit mobile number"
        value={mobile}
        onChange={(e) => setMobile(e.target.value.replace(/\D/g, ""))}
      />

      {isLoading && (
        <p className="text-sm text-gray-500 mt-2">Searching user...</p>
      )}

      {userInfo?.id && (
        <div className="mt-3 rounded-md border border-gray-200 bg-gray-50 p-3">
          <p className="text-sm text-gray-600">
            Name: <span className="font-semibold text-gray-900">{userInfo.name || "-"}</span>
          </p>
          <p className="text-sm text-gray-600">
            User Type: <span className="font-semibold text-gray-900 capitalize">{userInfo.user_type || "-"}</span>
          </p>
          <p className="text-sm text-gray-600">
            Mobile: <span className="font-semibold text-gray-900">{userInfo.mobile || "-"}</span>
          </p>
        </div>
      )}
    </div>
  );
};

export default BankUserLookup;
